import { FileTextIcon, ZapIcon, LanguagesIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Download immediato'
}, {
  icon: LanguagesIcon,
  label: 'Da zero assoluto'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: 'Garanzia 7 giorni'
}, {
  icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  icon: CreditCardIcon,
  label: 'Carta di credito / debito'
}, {
  icon: ZapIcon,
  label: 'Accesso a vita'
}];
export const stats = [{
  value: '500+',
  label: "Studenti felici"
}, {
  value: '6',
  label: 'Tomi completi'
}, {
  value: "99%",
  label: "lo consiglia"
}, {
  value: '4.9/5',
  label: "Valutazione\xA0⭐"
}];